import axios from "axios";
import ConstantList from "../appConfig";
import { getFormData } from "app/common/LocalFunction";

const API_PATH = ConstantList.API_EN_POINT + "/health-care-room";
const API_PATH_IMPORT = ConstantList.API_EN_POINT + "/excel";
const API_PATH_EXCEL = ConstantList.API_EN_POINT + "/excel";


export const pagingRoomAndService = (searchObject) => axios.post(API_PATH + "/search-service-room-by-page", searchObject);

export const getRoomAndServiceById = (productMappingId) => axios.get(API_PATH + "/get-service-room-by-id/" + productMappingId);

export const saveRoomAndService = productMapping => axios.post(API_PATH + '/save-service-room', productMapping);

export const markDeleteRoomAndService = productMappingId => axios.delete(API_PATH + '/mark-delete-service-room/' + productMappingId)

export const deleteRoomAndService = productMappingId => axios.delete(API_PATH + '/delete/' + productMappingId)

export const importExcelRoomAndService = (file) => {
    let formData = getFormData({ upload: file });
    return axios({
        url: API_PATH_IMPORT + '/import-service-room',
        headers: {
            "Content-Type": "multipart/form-data",
        },
        method: "POST",
        responseType: "blob",
        data: formData,
    })
}

export const downloadTemplate = () => {
    const url = API_PATH_EXCEL + "/dowload-template-service-room";
    return axios.post(
      url,
      {},
      {
        responseType: "blob",
      }
    );
  };

